import React from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import EditOrCreateFoodRestriction from '@/features/food-restrictions/EditOrCreateFoodRestriction'

export const Route = createFileRoute('/food-restrictions/new')({
  component: FoodGroupComponent,
})

function FoodGroupComponent() {
  const navigate = useNavigate()
  return <EditOrCreateFoodRestriction navigate={navigate} />
}
